<template>
  <SfButtonBase
    :component-type="componentType"
    :variant="variant"
    :small="small"
    :disabled="disabled"
    v-bind="$attrs"
    @click="handleClick"
  >
    <span
      class="sf-icon icon"
      :class="iconClass"
      data-testid="sf-button-icon"
    ></span>
  </SfButtonBase>
</template>
<script setup lang="ts">
import { computed } from 'vue'

import SfButtonBase from './sf-button-base.vue'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfButtonIcon',
})

interface Props {
  icon: string
  variant?: string
  small?: boolean
  disabled?: boolean
  seamless?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: '',
  small: false,
  disabled: false,
})

const emit = defineEmits(['click'])

const iconClass = computed(() => {
  return `icon-${props.icon}`
})

const componentType = computed(() => {
  return props.seamless ? ['icon', 'text'] : 'icon'
})

function handleClick(): void {
  emit('click')
}
</script>
